export default {
  oneParams: {
    title: '开户表格-个人',
    childrens: [
      {
        title: '开户表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Personal-Account-Opening.pdf'
      },
      {
        title: '(CRS-I (HK)) 个人税务 居民自我证明表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/CRS-Individual-Tax-Self-Certification-Form.pdf'
      }, {
        title: '业务条款及细则',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Business-Terms-and-Conditions.pdf'
      }
    ]
  },
  twoParams: {
    title: '开户表格-公司',
    childrens: [
      {
        title: '开户表格 (公司)',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Company-Account-Opening-Form.pdf'
      },
      // {
      //   title: '风险评估表格-公司客户',
      //   link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Risk-Assessment-Form.pdf'
      // },
      {
        title: '实体税务居民自我证明表格 (CRS-E (HK))',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Entity-Tax-Self-Certification-Form.pdf'
      },
      {
        title: '控权人税务居民自我证明表格 (CRS-CP (HK))',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Controlling-Person-Tax-Self-Certification-Form.pdf'
      },
      {
        title: '业务条款及细则',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Business-Terms-and-Conditions.pdf'
      }
    ]
  },
  threeParams: {
    title: '其他表格',
    childrens: [
      // {
      //   title: '中央结算交收指示表格',
      //   link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Ed-Central-robbery-settlement-instruction-form.pdf'
      // },
      {
        title: '取消或停用交易账户',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Cancellation-of-authorization-of-account-authorization.pdf'
      },
      // {
      //   title: '客户查证程序',
      //   link: 'http://download.eddidapp.com/pdf/SC/form/Customer-Verification.pdf'
      // },
      {
        title: '新增或更改个人资料或电邮户口通讯服务表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Account-Communication-Service-Form.pdf'
      },
      {
        title: '提款表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Aide-Withdrawal-Form.pdf'
      },
      {
        title: '股票实物存入表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Stock-Physical-Deposit-Form.pdf'
      },
      {
        title: '股票实物提取表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/Stock-Withdrawal.pdf'
      },
      {
        title: '结构性产品风险披露声明书',
        link: 'http://download.eddidapp.com/pdf/SC/risks-of-structured-products-disclosure-statement.pdf'
      },
      {
        title: '内部转账/货币兑换申请表格',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/SC/IFTCERForm.pdf'
      }
    ]
  }
}
